import React, { useContext } from 'react';
import { AppContext } from '../../utils/AppContext';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ReactGA from "react-ga4";
import Asset1 from "../../asset/new_asset/ilustration/lowallet_mobile.png";

const WalletSection = () => {
    const appContext = useContext(AppContext);
    const { t } = useTranslation();

    const desktopStyles = {
        containerStyle: {
            padding: "40px 80px",
            backgroundColor: appContext.colors.primaryBlue
        },

        headlineStyle: {
            fontSize: "46px",
            fontWeight: "500",
            lineHeight: "120%",
            fontFamily: appContext.fontFamily.inter,
            color: appContext.colors.primaryWhite,
            marginBottom: "40px"
        },

        subtitleStyle: {
            fontSize: "28px",
            fontWeight: "500",
            lineHeight: "120%",
            fontFamily: appContext.fontFamily.inter,
            color: appContext.colors.primaryWhite,
            marginBottom: "40px"
        },

        captionContainerStyle: {
            flex: "1",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: "column",
            padding: "20px",
            width: (window.innerWidth / 2 - 30) + "px",
        },

        imageAssetStyle: {
            width: "100%",
            padding: "5vh"
        },

        downloadButtonStyle: {
            textDecoration: "none",
            fontFamily: appContext.fontFamily.inter,
            fontSize: "20px",
            fontWeight: "600",
            marginLeft: "auto",
            padding: "10px 20px",
            borderRadius: "50px",
            color: appContext.colors.primaryBlue,
            backgroundColor: appContext.colors.primaryWhite,
        },
    }

    const mobileStyles = {
        containerStyle: {
            padding: "20px 16px",
            backgroundColor: appContext.colors.primaryBlue
        },

        headlineStyle: {
            fontSize: "22px",
            fontWeight: "500",
            lineHeight: "120%",
            fontFamily: appContext.fontFamily.inter,
            color: appContext.colors.primaryWhite,
            marginBottom: "15px"
        },

        subtitleStyle: {
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "120%",
            fontFamily: appContext.fontFamily.inter,
            color: appContext.colors.primaryWhite,
            marginBottom: "20px"
        },

        downloadButtonStyle: {
            textDecoration: "none",
            fontFamily: appContext.fontFamily.inter,
            fontSize: "14px",
            fontWeight: "600",
            padding: "10px 20px",
            borderRadius: "50px",
            color: appContext.colors.primaryBlue,
            backgroundColor: appContext.colors.primaryWhite,
        },

        imageAssetStyle: {
            width: "100%",
            marginTop: "60px"
        },

    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles


    const onDownload = () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        ReactGA.initialize("G-3CZYHKHHW6");
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            ReactGA.event({
                category: "download",
                action: "app_store"
            });
            window.open("https://woilo.com/appstore/ios.php?source=202", '_blank').focus();
            return;
        }
        ReactGA.event({
            category: "download",
            action: "play_store"
        });
        window.open("https://woilo.com/appstore/android.php?source=202", '_blank').focus();
    }

    return (
        <>
            <Container fluid style={styles.containerStyle}>
                <Row className='justify-content-center vertical-center'>
                    <Col className='my-auto' md={7}>
                        <h2 style={styles.headlineStyle}>{t('landingPage.walletSection.headline1')} <b>{t('landingPage.walletSection.headline2')}</b> {t('landingPage.walletSection.headline3')}<b> {t('landingPage.walletSection.headline4')}</b> </h2>
                        <h3 style={styles.subtitleStyle}>{t('landingPage.walletSection.subtitle')}</h3>
                        <Link style={styles.downloadButtonStyle} onClick={onDownload}>{t('landingPage.walletSection.download')}</Link>
                    </Col>
                    <Col className='justify-content-center' md={5}>
                        <Image style={styles.imageAssetStyle} src={Asset1} />
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default WalletSection;